var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMnt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2755_4751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: -1,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2755_4751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 0H15.8125V23H7.1875V0Z",
    fill: "#4C67E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8125 0H23V23H15.8125V0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H8.625V23H0V0Z",
    fill: "#C51918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32247 6.59726C3.59413 6.59726 3.68973 5.65105 3.68973 5.65105L4.03506 4.65669V5.05724V5.65105C4.03506 5.77895 4.16595 5.52316 4.16595 5.21523C4.16595 4.90731 4.32247 4.44622 4.32247 4.44622C4.32247 4.44622 4.32875 4.29204 4.33308 4.1398C4.35814 4.21813 4.40836 4.28595 4.4846 4.38891C4.49789 4.40686 4.51198 4.42589 4.52686 4.44622C4.61684 4.56917 4.6047 4.89486 4.5942 5.17665C4.58469 5.43186 4.57652 5.65105 4.64676 5.65105C4.79456 5.65105 4.78358 4.77056 4.78358 4.77056L5.03164 5.65105C5.03164 5.65105 5.05081 6.59726 4.32247 6.59726ZM4.32247 3.89506C4.341 3.75059 4.33866 3.94358 4.33308 4.1398C4.31217 4.0744 4.30879 4.00168 4.32247 3.89506ZM5.41827 8.32185C5.41827 9.0911 4.93558 9.71469 4.34014 9.71469C3.74471 9.71469 3.26202 9.0911 3.26202 8.32185C3.26202 7.5526 3.74471 6.929 4.34014 6.929C4.93558 6.929 5.41827 7.5526 5.41827 8.32185ZM2.70913 10.929H1.4375V19.1432H2.70913V10.929ZM7.1875 10.929H5.91587V19.1432H7.1875V10.929ZM3.04087 11.0004L4.28051 12.0238L5.67768 11.0004H3.04087ZM4.28051 19.1665L3.04087 18.1432H5.67768L4.28051 19.1665ZM3.04087 12.3575H5.63942V13.0004H3.04087V12.3575ZM5.63942 17.1432H3.04087V17.7861H5.63942V17.1432ZM4.36779 16.7861C5.10063 16.7861 5.69471 16.0186 5.69471 15.0718C5.69471 14.125 5.10063 13.3575 4.36779 13.3575C3.63495 13.3575 3.04087 14.125 3.04087 15.0718C3.04087 16.0186 3.63495 16.7861 4.36779 16.7861ZM2.8773 8.83207C2.8773 8.83207 2.92198 10.6216 4.24484 10.6216C5.56771 10.6216 5.78122 8.83207 5.78122 8.83207C5.78122 8.83207 5.26918 9.92827 4.32926 9.92827C3.38934 9.92827 2.8773 8.83207 2.8773 8.83207Z",
    fill: "#F8D000"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2755_4751)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_4751",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnt);
export default __webpack_public_path__ + "static/media/MNT.486edcd41407e4c5626f74557ca18608.svg";
export { ForwardRef as ReactComponent };